import { css } from '@emotion/react'

export const iconButtonStyle = css`
  &.button {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--Radius-100);
    transition:
      background 0.2s ease,
      border 0.2s ease;
  }

  /* size */
  &.button-xs {
    width: 30px;
    height: 30px;
  }

  &.button-s {
    width: 36px;
    height: 36px;
  }

  &.button-m {
    width: 40px;
    height: 40px;
  }

  &.button-l {
    width: 48px;
    height: 48px;
  }

  /* variant*/
  /* Filled */
  &.button-filled {
    background: var(--White);
    svg {
      color: var(--Colors-Gray-600);
    }

    &:hover {
      background: var(--Colors-Gray-100);
    }

    &:active {
      background: var(--Colors-Gray-300);
    }

    &[data-disabled='true'],
    &[data-loading='true'] {
      background: var(--Colors-Gray-100);
      cursor: not-allowed;
      svg {
        color: var(--Colors-Gray-400);
      }
    }
  }

  /* Line-filled */
  &.button-line-filled {
    background: var(--White);
    border: 1px solid var(--Colors-Gray-300);
    svg {
      color: var(--Colors-Gray-600);
    }

    &:hover {
      border: 1px solid var(--Colors-Gray-400);
      background: var(--Colors-Gray-100);
    }

    &:active {
      border: 1px solid var(--Colors-Gray-400);
      background: var(--Colors-Gray-300);
    }

    &[data-disabled='true'],
    &[data-loading='true'] {
      border: 1px solid var(--Colors-Gray-400);
      background: var(--Colors-Gray-100);
      cursor: not-allowed;
      svg {
        color: var(--Colors-Gray-400);
      }
    }
  }

  /* Ghost */
  &.button-ghost {
    svg {
      color: var(--Colors-Gray-600);
    }

    &:hover {
      background: var(--Colors-Gray-100);
    }

    &:active {
      background: var(--Colors-Gray-200);
    }

    &[data-disabled='true'],
    &[data-loading='true'] {
      background: transparent;
      cursor: not-allowed;
      svg {
        color: var(--Colors-Gray-400);
      }
    }
  }

  &.button-circle {
    position: relative;
    border-radius: var(--Radius-Circle);
    background-color: var(--Colors-Gray-800);
    overflow: hidden;
    transition: background-color 0.2s ease;

    svg {
      color: var(--White);
      transition: color 0.2s ease;
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-color: transparent;
      transition: background-color 0.2s ease;
      pointer-events: none;
      border-radius: inherit;
      z-index: 0;
    }

    &:hover::before {
      background-color: var(--Overlays-White-Alpha-10);
    }

    &:active::before {
      background-color: var(--Overlays-White-Alpha-20);
    }

    &[data-disabled='true'],
    &[data-loading='true'] {
      background-color: var(--Colors-Gray-100);
      cursor: not-allowed;

      svg {
        color: var(--Colors-Gray-400);
      }
    }
  }
`
